export const style = {
    stack: {
        
    },
    counter: {
        width: '100%',
        display:'flex',
        flexDirection:'column',
        justifyContent: 'center',
    },
    titleArea:{
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection:'row',
        margin: '20px 14px',
        width:'100%',
    },
    title:{
        margin: '0px',
        padding: '0px',
        fontSize: '16pt',
        fontWeight: 700,
        marginBottom: '12px',
        color: '#333',
        letterSpacing: '-0.02em',
    },
    panelArea: {
        display: 'grid',
        gridTemplateColumns: '300px 300px 300px',
        gap: '24px',
        width:'100%',
        justifyContent:'center',
        padding: '10px',
        '@media (max-width: 600px)': {
            gridTemplateColumns: '300px',
          }
    },
    cardAreaImageOff:{
        width: '320px',
        height:'240px',
        display:'flex',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        cursor: 'pointer',
        borderRadius: '16px',
        overflow: 'hidden',
        opacity: 0.6,
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        '@media (max-width: 600px)': {
            width: '300px',
            height:'200px',
          }
    },
    
    cardAreaImage:{
        width: '320px',
        height:'240px',
        display:'flex',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        cursor: 'pointer',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        transition: 'box-shadow 0.3s ease',
        '&:hover': {
            boxShadow: '0 8px 32px rgba(112, 33, 128, 0.25)',
         },
        justifyContent: 'center',
        alignItems: 'center',

        '@media (max-width: 600px)': {
            width: '300px',
            height:'230px',
          }
    },
    cardAreaContent:{
        display:'flex',
        width: '100%',
        height:'100%',
        margin: 0,
        padding: 0,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        background: 'linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.6) 100%)',
    },
    cardTitleArea: {
        position:'relative',
        bottom:'3rem',
        right:'0.5rem',
        textAlign:'right',
        width: '100%',
        color: '#FFF',
        padding: '12px',
    },
    cardTitle: { 
        fontSize: '15pt',
        fontWeight: 700,
        color: '#FFF',
        textShadow: '0 2px 8px rgba(0,0,0,0.3)',
    },
    iconCrown: {
        height: '18px',
        width: '18px',
        background: 'none',
        float:'right',
        position: 'relative',
        bottom: '200px',
        left: '290px',
        filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
    },
    
}
